/**
 * **The shortfall letters on paper** (ADR 0029; Commitment.dc.html `shortfall` · Print the N): one
 * page a family the letter went to on paper — the words are the ledger's own (`letterFor`), the
 * same the email carries. Sent letters only: nothing prints before a school person presses Send.
 */
import type { ReactNode } from 'react';
import { PrintRoot, formatDate } from '@cider/ui';
import { useLoad } from '../views/admin/shared.js';

interface Sent {
  familyId: string;
  name: string;
  channel: 'email' | 'paper';
  at: string;
  letter: { dear: string; paragraphs: string[]; signed: string };
}

export function ShortfallLetters({ year }: { year: string }): ReactNode {
  const v = useLoad<{ sent: Sent[] }>(`/volunteers/ledger/${year}/shortfall`);
  if (v.error) return <p role="alert">{v.error}</p>;
  if (!v.data) return <p>Writing the letters…</p>;
  const paper = v.data.sent.filter((x) => x.channel === 'paper');
  if (paper.length === 0)
    return (
      <p role="alert">No letter went on paper this year. They print once Send has been pressed.</p>
    );
  return (
    <PrintRoot
      kind="letter"
      title={`The shortfall letters · ${year}`}
      pages={paper.map((x) => (
        <div key={x.familyId} className="letter ask-letter">
          <div className="ask-letter__head">
            <div className="ask-letter__eyebrow">SAINT LAWRENCE CATHOLIC SCHOOL</div>
            <div className="ask-letter__parish">Apple Fest family commitment · {year}</div>
          </div>
          <p className="ask-letter__date">{formatDate(x.at, { year: true })}</p>
          <p>{x.letter.dear}</p>
          {x.letter.paragraphs.map((t) => (
            <p key={t}>{t}</p>
          ))}
          <p>{x.letter.signed}</p>
        </div>
      ))}
    />
  );
}
